import { render } from "./ContactFrom.vue?vue&type=template&id=4d7196cc&scoped=true"
import script from "./ContactFrom.vue?vue&type=script&lang=js"
export * from "./ContactFrom.vue?vue&type=script&lang=js"

import "./ContactFrom.vue?vue&type=style&index=0&id=4d7196cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d7196cc"]])

export default __exports__